import { render, staticRenderFns } from "./AddLinkPage.vue?vue&type=template&id=073a94d1&"
import script from "./AddLinkPage.vue?vue&type=script&lang=js&"
export * from "./AddLinkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports